import React from "react";
import Image from "next/image";
import { TEAL, K } from "./constant";
import { useT } from "providers/I18nProvider";

/** Hero landing /hop-tac: thông điệp + 2 CTA + 3 điểm tin cậy + ảnh chủ cơ sở */
const Hero: React.FC = () => {
  const t = useT();
  const trustPoints = [t("partner.trust1"), t("partner.trust2"), t("partner.trust3")];
  return (
    <section className="bg-gradient-to-b from-[#eefbfb] via-[#f7fdfd] to-white">
      <div className="container mx-auto px-4 md:px-6 py-8 md:py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span
            className="inline-block rounded-full bg-white border border-[#d8f3f2] px-4 py-1.5 text-xs font-bold uppercase tracking-wider"
            style={{ color: TEAL }}
          >
            {t("partner.heroBadge")}
          </span>
          <h1 className="mt-4 text-[30px] md:text-[40px] leading-tight font-extrabold text-black01">
            {t("partner.heroTitlePrefix")} <K>{t("partner.heroTitleK1")}</K>,<br />
            {t("partner.heroTitleMid")} <K>{t("partner.heroTitleK2")}</K>
          </h1>
          <p className="mt-4 text-gray-600 text-lg leading-relaxed">
            {t("partner.heroDesc")}
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#dang-ky"
              className="rounded-full px-7 py-3 font-bold text-white shadow-md transition-transform hover:scale-[1.03] active:scale-95"
              style={{ background: TEAL }}
            >
              {t("partner.heroCtaRegister")}
            </a>
            <a
              href="mailto:support@lookme.vn"
              className="rounded-full border border-[#d8f3f2] bg-white px-7 py-3 font-bold transition-colors hover:border-primary"
              style={{ color: TEAL }}
            >
              support@lookme.vn
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-[14px] text-gray-600">
            {trustPoints.map((text) => (
              <span key={text} className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: TEAL }} />
                {text}
              </span>
            ))}
          </div>
        </div>

        <div className="relative rounded-[28px] overflow-hidden shadow-lg aspect-[4/3]">
          <Image
            src="/partner/hero-owner.jpg"
            alt={t("partner.heroImageAlt")}
            fill
            priority
            sizes="(min-width: 1024px) 50vw, 100vw"
            className="object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
